import React, {ReactNode, useContext} from "react";
import {Button, message, Modal} from "antd";
import {useRequest} from "ahooks";
import {useRouter} from "next/router";
import {ExclamationCircleOutlined} from "@ant-design/icons";
import {apiSignUpA} from "@/services/exam_signup";
import {DetailContext} from "@/context/detailContext";
import {casLogin} from "@/utils/index";

type TPcSignupBtnA = {
  noPass: boolean;
  className?: string;
  childrenComponent?: ReactNode
}

const PCSignupBtnA: React.FC<TPcSignupBtnA> = (
  {
    noPass,
    className,
    childrenComponent
  }) => {
  // 从context继承
  const contextProps = useContext(DetailContext);
  const {userInfo, cert_id, data} = contextProps;
  const {type} = data;
  const {uid = undefined, isPassRealnameAuthentication} = userInfo;
  const router = useRouter();
  // 报名A系列考试
  const {run: doSignupA, loading: signupALoading} = useRequest(() => {
    return apiSignUpA(cert_id);
  }, {
    manual: true,
    onSuccess: (res) => {
      console.log(res);
      console.log(`cert_id是${cert_id}`);
      if (res.code === 200 && res.data?.isSignupExam) {
        if (noPass) {
          router.push({pathname: '/exam', query: {examId: res.data.examId, paperId: res.data.paperId, type}})
        } else {
          message.success('报名成功，前去考试', 1, () => {
            router.push({pathname: '/exam', query: {examId: res.data.examId, paperId: res.data.paperId, type}})
          })
        }
      } else {
        message.warning(res.msg || '报名失败，请稍后重试');
      }
    }
  })
  const signUpExam = async () => {
    if (!uid) {
      Modal.warning({
        title: '请先进行登录',
        content: '当前尚未登录',
        okText: '去登录',
        cancelText: '取消',
        onOk: () => {
          casLogin();
        }
      });
    } else if (!isPassRealnameAuthentication) {
      Modal.confirm({
        icon: <ExclamationCircleOutlined/>,
        title: '请先进行初级实名认证',
        content: '认证考试报名仅对实名用户开放，认证后才可报名',
        okText: '立即认证',
        cancelText: '取消',
        onOk: () => {
          window.open(`${process.env.NEXT_PUBLIC_PASSPORT_URL}/?tab=auth&type=realname`);
        }
      });
    } else {
      doSignupA()
    }
  }
  return (
    <>
      {childrenComponent ? <div onClick={() => signUpExam()}>{childrenComponent}</div> : (
        <Button
          loading={signupALoading}
          disabled={signupALoading}
          className={className}
          type="primary"
          onClick={() => signUpExam()}
        >
          {noPass ? '再考一次' : '立即考试'}
        </Button>
      )}
    </>
  )
}
export default PCSignupBtnA;
